export default __webpack_public_path__ + "static/media/MA Logo-no text.41a828b7.png";